import { marketsQueryOptions } from "api/queries/markets";
import type { WarmableQuery } from "routing/warmQueries";

export const queries = (): Array<WarmableQuery> => [marketsQueryOptions()];
